/** @jsx h */
import { useEffect, useRef } from 'preact/hooks';
import { labels } from '../config';
import FilterCheckbox from './FilterCheckbox';
// import { useAccordionStore } from '../store/store';
import { Accordion } from '@3pc/accordion';

const FilterFieldsetAccordion = ({
  id,
  facet,
  optionsActiveCount,
  triggerAjaxSubmit,
  pluginNamespace,
  accordionConfig,
  title,
}) => {
  // const [accordionIsOpen, setAccordionIsOpen] = useState(false);
  /* eslint-disable no-unused-vars */
  // const [isActive, setIsActive] = useState(false);
  /* eslint-enable no-unused-vars */

  // get some props from our store
  // const activeAccordions = useAccordionStore(state => state.activeAccordions);
  // const addAccordion = useAccordionStore(state => state.addAccordion);
  // const removeAccordion = useAccordionStore(state => state.removeAccordion);
  // check if the accordion is in the store, if yes accordion should be open by default
  // const initialAccordionState = activeAccordions?.includes(title);
  // console.log('activeAccordions', activeAccordions);

  let accordionInstance;
  const accordionItem = useRef(null);
  const accordionButton = useRef(null);
  const accordionPanel = useRef(null);
  const accordionPanelInner = useRef(null);

  function handleFilterCheckboxChange() {
    triggerAjaxSubmit();
  }

  // Accordion

  useEffect(() => {
    const accordion = accordionItem.current;
    const handler = accordionButton.current;
    const target = accordionPanel.current;
    const targetInner = accordionPanelInner.current;

    const config =
      accordion.dataset.accordionConfig &&
      JSON.parse(accordion.dataset.accordionConfig?.replaceAll("'", '"'));

    // if (config.initOpened) addAccordion(title);

    accordionInstance = new Accordion({
      handler,
      target,
      targetInner,
      ...config,
      // initOpened: initialAccordionState,
      toggleEnd: (_, state) => {
        /* when ajax gets triggered and the all the filter gets replaced, preact re-init this whole component
         * so the open accordion will always be close again, which is annoying.
         * to prevent that, we're using the store "Zustand" to keep the accordion state persistent
         */
        // if (state === 'show') {
        //   addAccordion(title);
        // } else {
        //   removeAccordion(title);
        // }
      },
    });

    accordionInstance.init();
  }, []);

  return (
    <div class="form form--search accordion accordion--form">
      <fieldset
        class="form__fieldset accordion__item"
        data-accordion-config={accordionConfig}
        ref={accordionItem}
      >
        <legend class="form__legend form__legend--medium form__legend--accordion">
          <button class="accordion__button" type="button" ref={accordionButton}>
            <span class="form__legend-text">
              {labels.faceting.filterFor} {facet.label}
              {optionsActiveCount > 0 ? (
                <span class="form__selection-indicator">
                  {optionsActiveCount}
                  <span class="sr-only">{labels.faceting.filterActive}</span>
                </span>
              ) : (
                ''
              )}
            </span>
            <span class="accordion__icon icon icon--chevron-down-thick">
              <svg class="icon__svg" role="img" aria-hidden="true">
                <use href="#icon-chevron-down-thick" />
              </svg>

              <span class="sr-only">{labels.faceting.filterOpen}</span>
            </span>
            <span class="accordion__icon icon icon--chevron-up-thick">
              <svg class="icon__svg" role="img" aria-hidden="true">
                <use href="#icon-chevron-up-thick" />
              </svg>

              <span class="sr-only">{labels.faceting.filterClose}</span>
            </span>
          </button>
        </legend>
        <div class="accordion__content" ref={accordionPanel}>
          <div class="accordion__content-inner" ref={accordionPanelInner}>
            <ul class="input-filter-container">
              {facet.options.length
                ? facet.options.map(option => (
                    <li key={option.name}>
                      <FilterCheckbox
                        option={option}
                        filterName={facet.name}
                        handleChange={handleFilterCheckboxChange}
                        pluginNamespace={pluginNamespace}
                        key={option.value}
                      />
                    </li>
                  ))
                : ''}
            </ul>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default FilterFieldsetAccordion;
